import FileUpload from './FileUpload'

module.exports = {
  FileUpload: FileUpload
}



// WEBPACK FOOTER //
// ./src/index.js